export default "/images/vendor/flag-icon-css/flags/1x1/gs.svg?e6ba1f5421701bbb23043f2654c77909";